import React from 'react';
/* eslint-disable */
export function DoubleArrowRight(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.5 9.75C10.5 9.50391 10.3906 9.23047 10.1992 9.01172L6.26172 4.85547C5.82422 4.41797 5.14062 4.39062 4.70312 4.80078C4.26562 5.23828 4.23828 5.92188 4.67578 6.35938L7.875 9.75L4.67578 13.168C4.23828 13.6055 4.26562 14.2891 4.70312 14.7266C5.14062 15.1367 5.82422 15.1094 6.26172 14.6719L10.1992 10.5156C10.3906 10.2969 10.5 10.0234 10.5 9.75ZM15.4492 9.01172L11.5117 4.85547C11.0742 4.41797 10.3906 4.39062 9.95312 4.80078C9.51562 5.23828 9.48828 5.92188 9.89844 6.35938L13.125 9.75L9.89844 13.168C9.48828 13.6055 9.51562 14.2891 9.95312 14.7266C10.3906 15.1367 11.0742 15.1094 11.5117 14.6719L15.4492 10.5156C15.6406 10.2969 15.75 10.0234 15.75 9.75C15.75 9.50391 15.6406 9.23047 15.4492 9.01172Z"
        fill="currentColor"
      />
    </svg>
  );
}
